import { render, staticRenderFns } from "./TablePreviewUploadPdfDienNuoc.vue?vue&type=template&id=f5f016d4&scoped=true"
import script from "./TablePreviewUploadPdfDienNuoc.vue?vue&type=script&lang=js"
export * from "./TablePreviewUploadPdfDienNuoc.vue?vue&type=script&lang=js"
import style0 from "./TablePreviewUploadPdfDienNuoc.vue?vue&type=style&index=0&id=f5f016d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f016d4",
  null
  
)

export default component.exports